import React from 'react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher: React.FC = () => {
  const { currentLanguage, setLanguage } = useLanguage();

  const languages = [
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
  ];

  const currentLang = languages.find(lang => lang.code === currentLanguage) || languages[0];

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'pt' ? 'en' : 'pt';
    setLanguage(newLanguage);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-2 text-white hover:text-brand-red hover:bg-gray-800"
      title={`Switch to ${currentLanguage === 'pt' ? 'English' : 'Português'}`}
    >
      <Globe size={16} />
      <span className="hidden md:inline">{currentLang.flag}</span>
      <span className="text-sm font-medium">{currentLang.code.toUpperCase()}</span>
    </Button>
  );
};

export default LanguageSwitcher;